/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_resale': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<defs><path pid="0" d="M7.216 8l1.86 1.86-1.767 1.768L2.18 6.5l5.128-5.128L9.076 3.14 7.216 5H17a3 3 0 0 1 3 3v2h-3V9c0-.662-.333-.993-1-.993L16.002 8H7.216zm.691 7h8.877l-1.86-1.86 1.767-1.768L21.82 16.5l-5.128 5.128-1.767-1.768 1.86-1.86H7a3 3 0 0 1-3-3v-2h3v1.023c0 .622.302.947.907.977z" id="svgicon_icon_service_resale_a"/></defs><g transform="translate(-2 -1)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_resale_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_resale_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_resale_a"/><g mask="url(#svgicon_icon_service_resale_b)" _fill="#586A92"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_resale.js